export default "__VITE_ASSET__DOJcnxj3__"